<app-material [material]="false">
    <div class="header" header>
        <h2>{{ "admin.toolMaintenancePlans.activities.title" | translate }}</h2>
        <app-button
            type="primary"
            class="button add-button"
            (click)="openActivityModal()">
            {{ "admin.toolMaintenancePlans.activities.add" | translate }}
        </app-button>
    </div>
    <div class="list" body>
        <div class="list-header">
            <app-search-bar [input]="searchQuery"
                            (search)="onSearch($event)">
            </app-search-bar>
        </div>
        <div class="list-body" *ngIf="!(loading$ | async)">
            <app-activity-order-list [activities]="activities"
                                     [isDragNDrop]="true"
                                     [isResponsive]="true"
                                     (onReorder)="onActivityReorder()"
                                     (onSelect)="onSelectActivity($event)">
            </app-activity-order-list>
        </div>
        <div class="no-activities" *ngIf="!(loading$ | async) && activities.length === 0">
            <p>{{ 'admin.toolMaintenancePlans.activities.noActivities' | translate }}</p>
        </div>

        <app-loading-spinner class="loader" *ngIf="(loading$ | async)"></app-loading-spinner>
    </div>
</app-material>

<app-activity-modal [title]="'admin.toolMaintenancePlans.activities.modal.addTitle' | translate"
                    [dropdownItems]="adaptRoles"
                    (submit)="onCreate($event)">
</app-activity-modal>
